import { signal } from '@preact/signals';

export const apiOffline = signal(false);
